import React from 'react';
import { motion } from 'framer-motion';
import { Flame, ArrowRight } from 'lucide-react';
export function TopOfferBar() {
  return <div className="relative w-full overflow-hidden bg-black" data-id="element-299">
      {/* Animated gradient backdrop */}
      <motion.div aria-hidden className="absolute inset-0 bg-[length:200%_200%] bg-gradient-to-r from-amber-500 via-orange-600 to-pink-600 opacity-90" animate={{
      backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-300" />
      {/* Shimmer sweep */}
      <motion.div aria-hidden className="absolute top-0 -left-1/3 h-full w-1/4 -skew-x-12 bg-white/25 blur-md pointer-events-none" animate={{
      x: ['0%', '600%']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut',
      repeatDelay: 1.5
    }} data-id="element-301" />

      <div className="relative z-10 container mx-auto max-w-5xl px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center" data-id="element-302">
        <p className="flex items-center gap-2 font-extrabold text-white tracking-wide text-sm md:text-base uppercase drop-shadow" data-id="element-303">
          <Flame className="w-5 h-5 shrink-0 animate-pulse" data-id="element-304" />
          Oferta de lanzamiento: hoy llevas los 3 bonos GRATIS
        </p>

        <motion.a href="https://pay.hotmart.com/U106480894G?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.06,
        y: -1
      }} whileTap={{
        scale: 0.96
      }} className="group relative shrink-0 inline-flex items-center gap-2 bg-white text-black font-extrabold text-sm md:text-base px-6 py-2.5 rounded-full shadow-[0_0_25px_-4px_rgba(255,255,255,0.7)] overflow-hidden" data-id="element-305">
          <span className="relative z-10" data-id="element-306">QUIERO MI OFERTA</span>
          <ArrowRight className="w-4 h-4 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-307" />
          <motion.span aria-hidden className="absolute top-0 -left-1/3 h-full w-1/3 -skew-x-12 bg-black/10 pointer-events-none" animate={{
          x: ['0%', '450%']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
          repeatDelay: 1
        }} data-id="element-308" />
        </motion.a>
      </div>
    </div>;
}